export enum EnumFieldName {
  "acessibilidade" = "Acessibilidade",
  "agencia" = "Agência",
  "agencia2" = "Agência 2",
  "anoCarroceria" = "Ano da Carroceria",
  "anoFabricacao" = "Ano de fabricação",
  "assentos" = "Assentos",
  "bairro" = "Bairro",
  "banco" = "Banco",
  "banco2" = "Banco 2",
  "bilhetadora" = "Bilhetadora",
  "caracteristicaLinha" = "Característica",
  "cargo" = "Cargo",
  "celular" = "Celular",
  "cep" = "CEP",
  "cidade" = "Cidade",
  "cliente" = "Cliente",
  "climatizacao" = "Climatização",
  "cnpj" = "CNPJ",
  "cobertura" = "Cobertura",
  "codigo" = "Código",
  "codigoPublico" = "Código Público",
  "codigoTarifa" = "Código Tarifário",
  "consorcio" = "Consórcio",
  "conta" = "Conta",
  "conta2" = "Conta 2",
  "cpf" = "CPF",
  "data" = "Data",
  "dataFim" = "Data Final",
  "dataInicio" = "Data Inicial",
  "dataInicioVigencia" = "Inicio da Vigência",
  "descricao" = "Descrição",
  "documento1" = "CPF/CNPJ do banco primário inválido",
  "documento2" = "CPF/CNPJ do banco secundário inválido",
  "duracao" = "Duração",
  "email" = "E-mail",
  "empresaTransporte" = "Empresa de Transporte",
  "entidade" = "Entidade",
  "estado" = "Estado",
  "formaPagamento" = "Forma de Pagamento",
  "funcao" = "Função",
  "horarioFinal" = "Horário Final",
  "horarioInicio" = "Horário Início",
  "inscricaoEstadual" = "Inscrição Estadual",
  "intervaloAberturaViagem" = "Abertura de Viagem",
  "latitude" = "Latitude",
  "linhaComum" = "Linha Comum",
  "logradouro" = "Endereço",
  "loja" = "Loja",
  "longitude" = "Longitude",
  "marca" = "Marca da Carroceria",
  "matricula" = "Matrícula",
  "modelo" = "Modelo",
  "motorista" = "Motorista",
  "nome" = "Nome",
  "nomeEstabelecimento" = "Nome do Estabelecimento",
  "nomeFantasia" = "Nome",
  "nomeFuncionario" = "Nome do Funcionário",
  "nomeLei" = "Lei",
  "numero" = "Número",
  "numeroLinha" = "Número da Linha",
  "numeroSerie" = "Número de Série",
  "operador" = "Motorista/Cobrador",
  "operadora" = "Operadora",
  "perfil" = "Perfil",
  "placa" = "Placa",
  "porcentagem" = "Porcentagem",
  "prazoEstorno" = "Prazo de Estorno",
  "programacaoViagem" = "Programação",
  "razaoSocial" = "Razão Social",
  "sentido" = "Sentido da Viagem",
  "sistemaBilhetagem" = "Sistema de Bilhetagem",
  "situacao" = "Situação",
  "tarifaIntegracao" = "Tarifa de Remuneração",
  "telefone" = "Telefone",
  "tipo" = "Tipo",
  "tipoCategoria" = "Categoria",
  "tipoCobranca" = "Tipo de Cobrança",
  "tipoDesconto" = "Tipo de Desconto",
  "tipoIntegracao" = "Tipo de Integração",
  "tipoLinha" = "Tipo de Linha",
  "tipoPassageiro" = "Tipo de Passageiro",
  "tipoPlataforma" = "Tipo Plataforma",
  "tipoPrazoIntegracao" = "Prazo de integração",
  "tipoServico" = "Tipo de Serviço",
  "tipoTarifacao" = "Tipo de Tarifação",
  "tipoValidacao" = "Tipo de Validação",
  "tipoVeiculo" = "Tipo de Veículo",
  "valorBase" = "Tarifa Base",
  "valorBaseVT" = "Tarifa Base VT",
  "valorDesconto" = "Valor do Desconto",
  "valorPerct" = "Valor Porcentagem",
  "valorPublico" = "Tarifa Pública",
  "valorRemuneracao" = "Tarifa Remuneração",
  "valorVT" = "Tarifa VT",
  "veiculo" = "Veículo",
}
